(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["recharge-section"]) return;
  try {
    
const cartButton = document.querySelector('#addToCart');

cartButton.addEventListener('click', () => {
    addItemToCart(16553549725742, 1, "6", "Months", "206908");
});

function addItemToCart (variant_id, quantity, shipping_interval_frequency, shipping_interval_unit_type, subscription_id) {
  data = {
      "quantity": quantity,
      "id": variant_id,
      "properties[shipping_interval_frequency]": shipping_interval_frequency, 
	    "properties[shipping_interval_unit_type]": shipping_interval_unit_type,            
	    "properties[subscription_id]": subscription_id
    }
  jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        window.location.href = '/cart'; 
      }
  });
  window.location = '/checkout';

} 

  } catch(e) { console.error(e); }
})();
})();
